module.exports = __webpack_public_path__ + "img/proyecto_10_mv.f784d1ed.png";